import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

export const getClientImages = createAsyncThunk(
  "notification/getClientImages",
  async (_, { rejectWithValue }) => {
    try {
      const apiClient = new APIClient();
      
      const response = await apiClient.get(
        "/api/v1/clients/notification/campaigns/images"
      );
    
      return response.data || response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || "Unknown error");
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  images: [],
};

const getClientImagesSlice = createSlice({
  name: "getClientImages",
  initialState,
  reducers: {
    resetGetClientImages: (state) => {
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getClientImages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getClientImages.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.images = action.payload;
      })
      .addCase(getClientImages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { resetGetClientImages } = getClientImagesSlice.actions;
export default getClientImagesSlice.reducer; 